import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    document.documentElement.lang = 'zh-CN';
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <IndexSection />
        <UpdatesSection />
        <FeaturesSection />
        <MediaSection />
        <ContactSection />
        <AboutSection />
        <AppSection />
        <FaqSection />
        <CardsSection />
        <CarouselSection />
        <CommentsSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}